import React from "react";
import { Link } from "react-router-dom";

const WarningModal = ({
  onCancel,
  onProceed,
  title,
  description,
  subDescription,
  confirmButtonText = "Proceed",
  cancelButtonText = "Cancel",
  showItems = false,
  unavailableItems = [],
  cartItems = [],
  isLoading = false
}) => {
  // Find unavailable item details based on IDs
  const unavailableItemDetails = cartItems.filter(item => 
    unavailableItems.includes(item.id)
  );

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-96">
        {/* Header Section */}
        <div className="flex items-center justify-center gap-3 mb-4">
          <img
            src="/Images/Menu/errorIcon.png" // Replace with your custom image URL
            alt="Warning"
            className="h-8 w-8"
          />
        </div>
        <h2 className="text-base font-bold text-center text-gray-50">
          WARNING!
        </h2>
        <p className="text-base font-bold text-gray-50 mb-4 text-center">
          {description}
        </p>
        <p className="text-base font-bold text-gray-50 mb-6 text-center">
          {subDescription}
        </p>
        
        {/* Unavailable Items List - Only shown when showItems is true */}
        {showItems && unavailableItemDetails.length > 0 && (
          <div className="mt-4">
            <h4 className="text-md font-medium mb-2 text-gray-700">Items not available:</h4>
            <div className="max-h-48 overflow-y-auto border border-gray-200 rounded p-2">
              {unavailableItemDetails.map(item => (
                <div key={item.id} className="py-2 border-b border-gray-100 last:border-b-0">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-gray-700">
                      {item.name_en || item.name}
                    </span>
                    <span className="text-gray-500 text-sm">
                      {item.has_variants 
                        ? `${item.items?.reduce((total, variantItem) => total + variantItem.quantity, 0)}x`
                        : `${item.quantity}x`
                      }
                    </span>
                  </div>
                  {item.has_variants && (
                    <div className="text-xs text-gray-500 ml-4 mt-1">
                      With variants
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        
        {/* Buttons */}
        <div className="flex justify-between gap-4 mx-5">
          <button
            className="border border-amber-100 text-amber-100 w-[116px] h-7 bg-white text-sm font-medium rounded-lg"
            onClick={onCancel}
          >
            {cancelButtonText}
          </button>
          <button
            className={`w-[116px] h-7 bg-amber-100 text-white text-sm font-medium rounded-lg ${
              isLoading ? "opacity-50" : ""
            }`}
            onClick={onProceed}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
